module.exports = __webpack_public_path__ + "img/_holidu_logo.c6223fc7.svg";